<template>

    <Dashboard0 v-if="utente.FK_ID_LIVELLO == 0"></Dashboard0>
    <Dashboard1 v-if="utente.FK_ID_LIVELLO == 1"></Dashboard1>
    <Dashboard2 v-if="utente.FK_ID_LIVELLO == 2"></Dashboard2>
    <Dashboard3 v-if="utente.FK_ID_LIVELLO == 3"></Dashboard3>

</template>



<script>
import Dashboard0 from '@/views/admins/Dashboard0.vue'
import Dashboard1 from '@/views/admins/Dashboard1.vue'
import Dashboard2 from '@/views/admins/Dashboard2.vue'
import Dashboard3 from '@/views/admins/Dashboard3.vue'


export default {
    name:"Dashboard",
    
    components:{
        Dashboard0,
        Dashboard1,
        Dashboard2,
        Dashboard3,
        
    },
    
    data:function(){
        return{
            filters:global.filters,
            t:global.t,
            utente:{},
            today: new Date(),
            startInterval:{},
            arrayRisultatiRicerca:new Array(),
            testo: "ciao mamma guarda come mi diverto"
        }
    },

    props: ['todo'],

    methods:{
        goToRoute: function(route){
            global.router.push(route);
        },
        varianti : function(){
            this.$root.appoggio.prodotto = {ID_PRODOTTO:1};
            this.$root.changeRoute('varianti');
        },
        ricercaResultHandler : function(data){
            this.arrayRisultatiRicerca = new Array();
            this.arrayRisultatiRicerca = data.RISULTATI;
        },
        testAlert : function(){   
            utils.alert.success("ciaone");
            utils.alert.warning("ciaone");
            utils.alert.info("ciaone");
            utils.alert.primary("ciaone");
            utils.alert.danger("ciaone");
        }
      
    },

    created: function () {
        this.utente = utils.clone(this.$root.utente);
        this.$root.startUp();
        return;
        if (this.$root.sidebarHasBeenResized == false){
            this.$root.sidebarHasBeenResized = true;
            setTimeout(() => {
                $('.sidebar-main-resize').click();
            },1000);
        }
        
        

    },
}
</script>